module.exports = __webpack_public_path__ + "static/media/RP-40.d820400c.pdf";